<template>
    <div class="mt-5">
        <div class="flex">
            <div class="mr-3">
                <label>
                    <input
                        type="radio"
                        v-model="order"
                        value="alphabetical"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                    />
                    {{ $t('messages.alphabetical') }}
                </label>
            </div>

            <div>
                <label>
                    <input
                        type="radio"
                        v-model="order"
                        value="value"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                    />
                    {{ nonAlphabeticalOrderText }}
                </label>
            </div>
        </div>
        <div>
            <apexcharts height="350" type="bar" :options="chartOptions" :series="series" ref="chart" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
    name: 'GraphSortable',
    components: {
        apexcharts: VueApexCharts,
    },
    props: {
        dataOrders: {
            type: Object,
            required: true,
        },
        inputOptions: {
            type: Object,
            required: true,
        },
        nonAlphabeticalOrder: {
            type: String,
            required: false,
        },
    },
    data: function () {
        return {
            order: 'alphabetical',
            chartOptions: this.inputOptions,
            series: this.inputOptions.series,
            nonAlphabeticalOrderText: this.nonAlphabeticalOrder
                ? this.nonAlphabeticalOrder
                : this.$t('messages.order_by_grade'),
        };
    },
    watch: {
        order: function (newOrder) {
            const order = newOrder === 'alphabetical' ? 'alphabetical' : 'other';

            this.series = this.dataOrders[order].series;

            let options = this.inputOptions;
            options.xaxis.categories = this.dataOrders[order].labels;
            this.chartOptions = options;

            this.$refs.chart.updateOptions(options);
        },
    },
};
</script>
